import {directoriesService} from "../../services/directories-service";
import {call, put, takeEvery} from 'redux-saga/effects';
import {GET_DIRECTORIES} from "../actions/actionTypes";
import {
    errorMessages,
    openModal,
    setDirectoriesIssuingAuthority,
    setDirectoriesSoato,
    setDirectoriesTerrorist,
    setIssuingAuthorityDirectory,
    setSoatoDirectory,
    setTerroristDirectory,
} from "../actions/directories";
import {messages} from "../../helpers/messages";

const getTerroristDirectories = async (data = {}) =>
    await directoriesService.getIndexTerrorist(data)
        .then(data => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages[0]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })

const getSoatoDirectoriesZip = async (data) =>
    await directoriesService.getIndexSoatoZip(data)
        .then(data => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages[0]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })

const getIssuingAuthorityDirectoriesZip = async (data) =>
    await directoriesService.getIndexIssuingAuthorityZip(data)
        .then(data => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages[0]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })

const getSoatoDirectories = async () =>
    await directoriesService.getIndexSoato()
        .then(data => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages[0]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })

const getIssuingAuthority = async () =>
    await directoriesService.getIndexIssuingAuthority()
        .then(data => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages[0]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })

function* fetchDirectories(data) {
    try {
        if (data.payload.soatoCheckbox) {
            const result = yield call(() => getSoatoDirectories())
            yield put(setDirectoriesSoato(result.data))
        }
        if (data.payload.terroristCheckbox) {
            const result = yield call(() => getTerroristDirectories())
            yield put(setDirectoriesTerrorist(result.data))
        }
        if (data.payload.issuingAuthorityCheckbox) {
            const result = yield call(() => getIssuingAuthority())
            yield put(setDirectoriesIssuingAuthority(result.data))
        }
        if (data.payload.soato) {
            const result = yield call(() => getSoatoDirectoriesZip(data.payload.soato))
            yield put(setDirectoriesSoato(result.data))
        }
        if (data.payload.issuingAuthority) {
            const result = yield call(() => getIssuingAuthorityDirectoriesZip(data.payload.issuingAuthority))
            yield put(setDirectoriesIssuingAuthority(result.data))
        }
        if (data.payload.terrorist) {
            const result = yield call(() => getTerroristDirectories(data.payload.terrorist))
            yield put(setDirectoriesTerrorist(result.data))
        }
        yield put(setTerroristDirectory(null))
        yield put(setSoatoDirectory(null))
        yield put(setIssuingAuthorityDirectory(null))
        yield put(openModal({isOpen: false}))
    } catch (e) {
        yield put(errorMessages(e))
    }
}

function* directoriesSaga() {
    yield takeEvery(GET_DIRECTORIES, fetchDirectories)
}

export {
    directoriesSaga,
}
